// Constants

export const API_URL: string = location.protocol+ '//' + window.location.hostname + '/CSWebAPI/api/'; 
// export const API_URL: string = 'http://' + window.location.hostname + ':53790/api/';

export const SIGNAPI_URL: string = 'https://eremote.prophoenix.com/eSign/api/';


// Api Controller Names Starts

export const API_Home: string = 'Home';
export const API_Agency: string = 'Agency';
export const API_Tenant: string = 'Tenant';
export const API_SuperAdminAuthentication: string = 'SuperAdminAuthentication';
export const API_Authentication: string = "Authentication";
export const API_Citizen: string = 'Citizen';
export const API_Address: string = 'Address';
export const API_Contact: string = 'Contact';
export const API_Camera: string = 'Camera';
export const API_Flag: string = 'Flag';
export const API_LangText: string = 'Langtext';
export const API_HouseCheck: string = 'Service';
export const API_OnlineReport: string = 'OnlineReport';
export const API_Param: string = 'Param';
export const API_Alert: string = 'Alert';
export const API_Password: string = 'Password';
export const API_Screens: string = 'Screen';
export const API_NewTenant: string = 'NewTenant';
export const API_GetAllTenants: string = 'GetAllTenants';
export const API_IncidentType: string = 'IncidentType';
export const API_AnonymousTips: string = 'CreateAnonymsTips';
export const API_WantedPerson: string = 'WantedPerson';
export const API_Alarm: string = 'Alarm';
export const API_MaintenanceMsg: string = "MaintenanceMsg";
export const API_PDFService: string = "pdfviewer";
export const API_JobApplication: string = 'Jobapplication';
export const API_CitPermit: string = 'CitPermit';

//Coded
export const API_UpdateCoded: string  ='UpdateCoded'
export const API_GetDropdown: string  ='GetCodedDropdownValues'

// Permit

export const API_Permit: string = 'Permit';
export const API_PermitMonth: string = 'PermitMonth';

// Api Controller Names Ends


// Api Action Method Names Starts

export const API_Create: string = 'Create';
export const API_Update: string = 'Update';
export const API_ScreenContent: string = 'ScreenContent';
export const API_IncidentMapData: string = 'IncidentMap';
export const API_IncidentCSFCodeType: string = 'Coded';
export const API_IncidentMapDataGeoLoaction: string = 'geolocation';
export const API_Juris: string = 'Juris';
export const API_HeatMapData: string = 'Heat';
export const API_RoadClosure: string = 'RoadClosure';
export const API_RoadClosureMarker: string = 'RoadClosure/RoadMarker';
export const API_NameDtl: string = 'NameDtl';
export const API_HouseCheckHistory: string = 'History';
export const API_HouseCheckHistoryByNameID: string = 'ViewHistory';
export const API_API_CitService: string = 'CitService';
export const API_CitServiceHist: string = 'CitServiceHist';
export const API_GetTenant: string = 'TenantName';
export const API_TenantID: string = 'TenantID';
export const API_UpdateTenant: string = 'UpdateTenant';
export const API_GetCitizenInfo: string = 'GetCitizenInfo';
export const API_GetAddress: string = 'GetAddress';
export const API_GetCodeValue: string = 'GetCodeValue';
export const API_GetCodedValues: string = 'Coded';
export const API_PatrolArea: string = 'PatrolArea';
export const API_VehicleModel: string = 'VehicleModel';
export const API_ForgetPassword: string = 'ForgetPassword';
export const API_ResetPassword: string = 'ResetPassword';
export const API_HouseCheckInsert: string = 'HouseCheckInsert';
export const API_GetNibrsValues: string = 'GetNibrsValues';
//Report
export const API_GetOnlineReport: string = 'GetOnlineReport';
export const API_CORSUpdate: string = 'CORSUpdate';
export const API_GetWantedPerson: string = 'GetWantedPerson';

//Alarm
export const API_GetAlarmType: string = 'GetAlarmType';
export const API_GetAlarmByID: string = 'GetAlarmByID';
export const API_GetAlarmByCitizenID: string = 'GetAlarmByCitizenID';

//Services
export const API_AccidentReport: string = 'AccidentReport';
export const API_AccidentReportInquiry: string = 'Inquiry';
//Services => Complaints
export const API_OtherComplaints: string = 'CreateOtherCompliant';
//Services => Service Request
export const API_ServiceRequest: string = 'CreateServiceRequest';
//Services => Complaints
export const API_GetServiceDetails: string = 'GetServiceDetails';

//Maintenance Message
export const API_MaintenanceMsgCreate: string = "CreateMessage";
export const API_GetMaintenanceMessage: string = "GetMessage";

// Api Action Method Names End

// Payment

export const API_Payment: string = 'payment';
export const API_GetAllInvoice: string = 'GetAllInvoice';
export const API_GetAttachement: string = 'GetAttachement';
export const API_GetUnpaidInvoice: string = 'GetUnpaidInvoice'; // Need to Change and Review

/*** Admin Module ***/

//Juris Management

export const API_GetAllJuris: string = 'GetAllJuris';
export const API_GetJurisById: string = 'GetJurisById';
export const API_UpdateJuris: string = 'UpdateJuris';
export const API_AddJuris: string = 'Create';

//Incident Type
export const GetOnlineReportsIncidents: string = 'GetOnlineReportsIncidents';
export const API_GetIncidentTypes: string = 'GetIncidentTypes';
export const API_GetIncidentTypeByID: string = 'GetIncidentTypeByID';
export const API_CreateIncidentType: string = 'CreateIncidentType';
export const API_UpdateIncidentType: string = 'ModifyIncidentType';
export const API_GetIncidentByRadius: string = 'GetIncidentByRadius';
export const API_GetCounty: string = 'GetCounty';

//Police Alerts
export const API_UpdateBOLOMessage: string = 'UpdateBoloMessage';

//Crime Statistics
export const API_Crimestatistics: string = 'Crimestatistics';
export const API_GetCrimeStatPath: string = 'GetCrimeStatPath';
export const API_GetReport: string = 'GetReport';
export const API_Maintenance: string = "CreateMaintenance";

//Admin User document

export const API_DownloadUserDocument: string = 'DownloadUserDocument';

export const API_HouseCheckService: string = 'GetHouseCheckService';

//pawn

export const API_Pawn: string = 'Pawn';
export const API_PawnSearch: string = 'PawnSearch';
export const API_PawnDealer: string = 'GetPawnDealer';
export const API_PawnbyId: string = 'GetPawnByID';


//CitPermit
export const API_CitPermitRequest: string = 'CreatePermitRequest';
export const API_GetCitPermitDetails: string = 'GetPermitDetails';
export const API_GetCitPermitTypeDetails: string = 'GetPermitTypeDetails';
export const API_GetCitPermitPublicData: string = 'GetPermitPublicData';




// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/apiconfig.ts